module.exports = "# Level Completed\n\n## Content\n\n### Welcome back!\n* Click the MENU button (top left) and use MODULES to go back to any of the six modules.\n* Or check out the videos in the EXTRAS section!\n\n## Notes\n\nWelcome back!\n"


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/levelCompleted.md
// module id = 1818
// module chunks = 2